/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_TipInputs */

const en_pc_tut_search_tip = /** @type {(inputs: Pc_Tut_Search_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanned PDFs have no text layer. Run Scan & OCR first, which currently handles Latin scripts.`)
};

const zh_pc_tut_search_tip = /** @type {(inputs: Pc_Tut_Search_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描版 PDF 没有文字层。请先运行「Scan & OCR」，目前支持拉丁文字。`)
};

/**
* | output |
* | --- |
* | "Scanned PDFs have no text layer. Run Scan & OCR first, which currently handles Latin scripts." |
*
* @param {Pc_Tut_Search_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_tip = /** @type {((inputs?: Pc_Tut_Search_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_tip(inputs)
	return zh_pc_tut_search_tip(inputs)
});
export { pc_tut_search_tip as "pc.tut.search.tip" }